/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/react-in-jsx-scope */
import { Grid, IconButton } from "@material-ui/core";
import { useParams } from "@reach/router";
import useText from "constants/text";
import { useCourseContext } from "contexts/CourseContext";
import { InfoBarContext } from "contexts/InfoBarContext";
import { ICoursePickup, IDelivery, Iproduct, modalType } from "domains/Course/data/types";
import { NewAddress, useDeliveryStyles } from "domains/Course/style";
import { Address } from "generated/graphql";
import { EditIcon } from "icons";
import { formatIncompletePhoneNumber } from "libphonenumber-js";
import { memo, useMemo, useState } from "react";
import Autocomplete from "ui/Autocomplete";
import { TextField } from "ui/TextField";
import { displayFullName, formatDate, truncateString } from "utils";
import { Divider } from "../Divider";
import AddressModal from "../modals/AddressModal";
import SelectMultiple from "./CustomSelectMultiple";

const Delivery = ({ deliveryIndex, isEdit }: IDelivery) => {
  const { text } = useText();
  const classes = useDeliveryStyles();
  const [isDelay, setIsDelay] = useState<boolean>(true);

  const {
    deliveries,
    pickups,
    editDelivery,
    isSubmitted,
    allAvailableProducts,
    setAllProducts,
    allProducts,
    clientAddresses,
    validateCourseDateAndTime,
  } = useCourseContext();
  const [selectedOption, setSelectedOption] = useState<any[]>(deliveries[deliveryIndex]?.products);

  const [openModal, setOpenModal] = useState({
    selecetPickupAddress: false,
  });

  const toggleModal = (modal: string) => {
    setOpenModal({ ...openModal, [modal]: !openModal[modal] });
  };

  const pickUpAddress = useMemo(
    () =>
      pickups
        ?.map(({ address, products }) => {
          if (!products?.every((product) => allAvailableProducts?.includes(product?.name))) {
            return address;
          }
        })
        ?.filter((address: any) => {
          if (address) {
            return address;
          }
        }),
    [deliveries, pickups, allAvailableProducts]
  );

  const getOptionLabelAddress = (value: any) =>
    `${truncateString(value?.address?.address, 20)} ${value?.firstname}, ${
      value?.lastname
    } ${formatIncompletePhoneNumber(`${value?.phone_number || value?.phoneNumber}`)}`;

  const renderRowAddress = (value: any) => {
    return (
      <div className={classes.rootAddress}>
        <span className={classes.nameContent}>{truncateString(value?.address?.address, 20)}</span>
        <span className={classes.cel}>{displayFullName(value?.firstname, value?.lastname)}</span>
        <span className={classes.cel}>
          {formatIncompletePhoneNumber(`${value?.phone_number || value?.phoneNumber}`)}
        </span>
      </div>
    );
  };

  const setProductsToEdit = () => {
    const currentPickupProducts = pickups?.find(
      (pickup: ICoursePickup) =>
        pickup?.address?.address?.place_id === deliveries[deliveryIndex]?.pickupAddress?.address?.place_id
    )?.products;

    currentPickupProducts &&
      setAllProducts([
        ...deliveries[deliveryIndex]?.products?.filter((product) => allAvailableProducts?.includes(product.name)),
        ...currentPickupProducts?.filter((product) => !allAvailableProducts?.includes(product.name)),
      ]);
  };

  const getValidDelay = (value: string) =>
    !isTime()
      ? formatDate(value, "yyyy-MM-dd")
      : `${formatDate(value, "yyyy-MM-dd")} / ${deliveries[deliveryIndex]?.delay?.split("/")[1]?.trim()}`;

  const deliveryFormhandler = {
    handleChangePickupAddress: (_: any, value: Address | any, reason: string) => {
      const pickup = pickups?.find(({ address }) => address?._id === value?._id);
      const products = pickup?.products || [];
      editDelivery(deliveryIndex, "pickupAddress", value, pickup?.reference);
      setAllProducts([...products?.filter((product) => !allAvailableProducts?.includes(product?.name))]);
      setSelectedOption([]);
    },

    handleProducts: (values: Iproduct[]) => {
      editDelivery(deliveryIndex, "products", values);
    },

    handleDelay: (event: any) => {
      editDelivery(deliveryIndex, "delay", getValidDelay(event.target.value));
    },

    handleTime: (event: any) => {
      const delay = deliveries[deliveryIndex]?.delay?.split("/")[0].trim();
      editDelivery(deliveryIndex, "delay", `${delay}${` / ${event?.target?.value}`}`);
      setIsDelay(false);
    },
  };

  const togglSelectAddress = () => {
    toggleModal("selecetPickupAddress");
  };

  const filteredProducts = useMemo(() => {
    return [...allProducts];
  }, [pickups, allProducts]);

  const isTime = () => deliveries[deliveryIndex]?.delay?.includes("/");
  const onHandleDelayEdit = () => setIsDelay(false);
  const handleIsDelay = () => {
    setIsDelay(!isDelay);
  };

  return (
    <Grid>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Autocomplete
            options={pickUpAddress || []}
            blurOnSelect
            label={text.all.pickup_address}
            getOptionLabel={getOptionLabelAddress}
            renderOption={renderRowAddress}
            onChange={deliveryFormhandler.handleChangePickupAddress}
            value={deliveries[deliveryIndex]?.pickupAddress}
            noOptionsText={<b> {text.all.unavailable_pickup_address}</b>}
            error={isSubmitted && !deliveries[deliveryIndex]?.pickupAddress}
          />
        </Grid>

        <Grid item xs={12}>
          <SelectMultiple
            onChange={deliveryFormhandler.handleProducts}
            options={filteredProducts}
            label={text.all.product_to_deliver}
            noItemAvailable={text.all.no_available_product}
            error={isSubmitted && !deliveries[deliveryIndex]?.products?.length}
            isEdit
            selectedOption={deliveries[deliveryIndex]?.products}
            isProducts={!!deliveries[deliveryIndex]?.pickupAddress}
          />
        </Grid>
        <Grid item xs={12}>
          {deliveries[deliveryIndex]?.deliveryAddress ? (
            <Grid item xs={12}>
              <>
                <TextField
                  label={text.all.delivery_address}
                  required
                  variant="outlined"
                  value={`${truncateString(deliveries[deliveryIndex]?.deliveryAddress?.address?.address, 20)}, ${
                    deliveries[deliveryIndex]?.deliveryAddress?.firstname
                  }, ${deliveries[deliveryIndex]?.deliveryAddress?.lastname} ${
                    deliveries[deliveryIndex]?.deliveryAddress?.phoneNumber ||
                    deliveries[deliveryIndex]?.deliveryAddress?.phone_number
                  }`}
                  name="address"
                  fullWidth
                  error={isSubmitted && !deliveries[deliveryIndex]?.deliveryAddress?.address?.place_id}
                />
                <IconButton onClick={togglSelectAddress} className={classes.editAddress}>
                  <EditIcon width={20} />
                </IconButton>
              </>
            </Grid>
          ) : (
            <NewAddress
              error={isSubmitted && deliveries[deliveryIndex]?.deliveryAddress?.address?.address === undefined}
              onClick={togglSelectAddress}
            >
              {text.all.select_delivery_address}
            </NewAddress>
          )}
        </Grid>
        {deliveries[deliveryIndex]?.delay?.split("/")[1]?.trim() && (
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              label={text.all.delay}
              name="product"
              fullWidth
              placeholder="Product description"
              value={deliveries[deliveryIndex]?.delay}
              className={`${classes.disabled} ${classes.delayError}`}
              InputProps={{
                className:
                  (isSubmitted && !deliveries[deliveryIndex]?.delay?.split("/")[1]?.trim()) ||
                  validateCourseDateAndTime(deliveryIndex)?.isdelayValid ||
                  validateCourseDateAndTime(deliveryIndex)?.isTimeValide
                    ? classes.delayError
                    : "",
              }}
              error={
                (isSubmitted && !deliveries[deliveryIndex]?.delay?.split("/")[1]?.trim()) ||
                validateCourseDateAndTime(deliveryIndex)?.isdelayValid ||
                validateCourseDateAndTime(deliveryIndex)?.isTimeValide
              }
            />
            <IconButton onClick={handleIsDelay} className={classes.editAddress}>
              <EditIcon width={20} />
            </IconButton>
            <small className={classes.delayError}>
              {(isSubmitted && !deliveries[deliveryIndex]?.delay?.split("/")[1]?.trim()) ||
                ((validateCourseDateAndTime(deliveryIndex)?.isdelayValid ||
                  validateCourseDateAndTime(deliveryIndex)?.isTimeValide) &&
                  text.course.course_delay_validation_error)}
            </small>
          </Grid>
        )}
        {isDelay && (
          <Grid item container spacing={4}>
            <Grid item xs={12}>
              <Divider prefix={text.all.delay} />
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                id="date"
                name="delay"
                label={text.all.date}
                type="date"
                value={deliveries[deliveryIndex]?.delay?.split("/")[0]?.trim()}
                onChange={deliveryFormhandler.handleDelay}
                defaultValue={deliveries[deliveryIndex]?.delay?.split("/")[0]?.trim()}
                onBlur={onHandleDelayEdit}
                InputLabelProps={{
                  shrink: true,
                }}
                error={
                  (isSubmitted && !deliveries[deliveryIndex]?.delay?.split("/")[0]?.trim()) ||
                  validateCourseDateAndTime(deliveryIndex)?.isdelayValid
                }
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label={text.all.time}
                type="time"
                defaultValue={deliveries[deliveryIndex]?.delay?.split("/")[1]?.trim()}
                onChange={deliveryFormhandler.handleTime}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  min: "9:00",
                  max: "16:00",
                }}
                disabled={!deliveries[deliveryIndex]?.delay}
                error={
                  (isSubmitted && !deliveries[deliveryIndex]?.delay?.split("/")[1]?.trim()) ||
                  validateCourseDateAndTime(deliveryIndex)?.isTimeValide
                }
              />
            </Grid>
          </Grid>
        )}
      </Grid>
      <AddressModal
        onClose={togglSelectAddress}
        modalType={modalType.DELIVERY_MODAL}
        itemIndex={deliveryIndex}
        open={openModal.selecetPickupAddress}
      />
    </Grid>
  );
};

export default memo(Delivery);
